import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS } from '@modules/general-settings/submodules/table-columns-settings/constants';

import type { ITableColumnsResponse } from '../types';
import {
  TABLE_COLUMNS_LIST_API_URL,
  TABLE_DISABLED_COLUMNS_LIST_QUERY,
  TABLE_ENABLED_COLUMNS_LIST_QUERY,
} from '../constants';
import { TableColumnsListType } from '../types';

export default function useTableColumnsQuery(
  listType: TableColumnsListType,
  tableId: Ref<number>,
  isEnabled: Ref<boolean>,
): IContextQueryResult<ITableColumnsResponse> {
  const { fetchGet } = useRestClient();

  return useContextQuery<ITableColumnsResponse>({
    queryKey: [
      listType === TableColumnsListType.ENABLED ? TABLE_ENABLED_COLUMNS_LIST_QUERY : TABLE_DISABLED_COLUMNS_LIST_QUERY,
      tableId,
    ],
    queryFn: ({ signal }) => fetchGet<ITableColumnsResponse>(
      TABLE_COLUMNS_LIST_API_URL,
      {
        queryParams: {
          table_id: tableId.value,
        },
        urlParams: {
          listType,
        },
        signal,
        permission: ADMIN_GENERAL_SETTINGS_TABLE_COLUMNS_SETTINGS_PERMISSIONS.EDIT,
      },
    ),
    enabled: computed(() => !!tableId.value && isEnabled.value),
  });
}
